module.exports = __webpack_public_path__ + "img/97.7.3aeb0044.png";